import { StackModalProps, useModals } from 'almanac-ui/Modal'
import { FunctionComponent, useCallback } from 'react'

export interface ConfirmModal extends StackModalProps {
  onCancel: () => void
  onConfirm: () => void
  onPressOutside: () => void
}

export interface ConfirmModalProps {
  msg: string
  confirmText?: string
  title?: string
}

export const useConfirmModal = (Modal: FunctionComponent<React.PropsWithChildren<ConfirmModal>>) => {
  const { openModal, closeModal } = useModals()
  return useCallback(
    (props?: ConfirmModalProps) =>
      new Promise<boolean>((resolve) => {
        const modalProps = {
          onCancel: () => {
            resolve(false)
            closeModal()
          },
          onConfirm: () => {
            resolve(true)
            closeModal()
          },
          onPressOutside: () => {
            resolve(false)
            closeModal()
          },
          ...props,
        }
        openModal(Modal, modalProps, { newStack: true })
      }),
    [openModal, closeModal, Modal],
  )
}
